import Review from '../records/Review';

export const getUserMarkedHelpful = (userId: string, review: Review) => {
  return (
    review &&
    review
      .get('attributes')
      .some(
        (attr) =>
          (attr.get('userId') === userId ||
            attr.get('userId') === Number(userId)) &&
          attr.get('helpful')
      )
  );
};
